<template>
  <div class="qir-our-team__wrapper full-width-section">
    <div class="qir-our-team__container">
      <h2 class="qir-our-team__title title">
        Our Team, Your Experts
      </h2>

      <p class="qir-our-team__description text-body">
        Get to know the talented team driving our analyses, and forecasts.
      </p>

      <div class="qir-our-team__team-members-wrapper">
        <team-slider
          :team-members="teamMembers"
          class="qir-our-team__team-members-slider"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TeamSlider from 'sections/_shared/TeamSlider/index.vue'

export default {
  name: 'QirOurTeam',
  components: {
    TeamSlider
  },
  data() {
    return {
      teamMembers: [
        {
          name: 'Sylwester Majewski',
          description:
            'A graduate of the Warsaw School of Economics, Sylwester received an MA specializing in finance and banking. As Finance Magnates’ research associate and STA certified analyst, he leaves no stone unturned. Sylwester is the previous minority partner of an NFA registered US broker, and since 2003, has participated in many projects.',
          imageSrc: '/images/team/sylwester-majewski-1.png',
          altText: 'Sylwester Majewski'
        },
        {
          name: 'Ramzi Ahmad',
          description:
            'With over 16 years of experience in data-driven marketing within the financial industry, Ramzi Ahmad has developed expertise across Fintech, Crypto, Payments, and Online Trading markets. He has led teams to improve efficiency and drive growth for dozens of financial brands through actionable data insights. Ramzi continues to advance his skills through courses at institutions like Harvard and Cambridge, ensuring the highest standards of data accuracy.',
          imageSrc: '/images/team/ramzi-ahmad-1.png',
          altText: 'Ramzi Ahmad'
        },
        {
          name: 'Damian Chmiel',
          description:
            'Damian’s adventure with the financial markets began at the Cracow University of Economics, where obtained his MA in finance and accounting. Starting from the retail trader perspective, he collaborated with brokerage houses and financial portals in Poland as an independent editor and content manager. His adventure in Finance Magnates began in 2016 where he develops as a business intelligence analyst.',
          imageSrc: '/images/team/damian-chmiel-1.png',
          altText: 'Damian Chmiel'
        },
        {
          name: 'Jeffery Patterson',
          description:
            'Jeffery joined the team in late 2013 as an editor, where armed with unique insight and drive, he helped develop the “Meet the Experts” portal, which was amalgamated into the “Executives” platform on Finance Magnates. Jeffery began covering the industry back in 2011 as a research analyst and editor at FXStreet. He holds degrees in economics, political science, and geology.',
          imageSrc: '/images/team/jeffery-patterson-1.png',
          altText: 'Jeffery Patterson'
        },
        {
          name: 'Arnab Shome',
          description:
            'Arnab is an electronics engineer-turned-financial editor. He entered the industry covering the cryptocurrency market for Finance Magnates and later expanded his reach to online trading as well. He is passionate about the changing regulatory landscape on financial markets and keenly following the disruptions in the industry with new-age technologies.',
          imageSrc: '/images/team/arnab-shome-1.png',
          altText: 'Arnab Shome'
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.qir-our-team__wrapper {
  background: $c--gray-dark;

  .qir-our-team__container {
    max-width: $desktop-container;

    $padding: (
      $above-desktop-xl: 96px $padding-x-desktop-full-hd,
      $desktop-md: 64px $padding-x-desktop-md,
      $mobile: 32px $padding-x-mobile
    );

    @include setStyleByBreakpoint('padding', $padding);
  }

  .qir-our-team__title {
    $margin-bottom: (
      $above-desktop-xl: 10px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .qir-our-team__description {
    margin-top: 20px;
    color: $c--text-secondary;

    @include mobile {
      font-size: 20px;
      line-height: 30px;
    }
  }

  .qir-our-team__team-members-wrapper {
    $margin-top: (
      $above-desktop-xl: 64px,
      $desktop-md: 32px,
      $mobile: 24px
    );

    @include setStyleByBreakpoint('margin-top', $margin-top);
  }
}
</style>
